module.exports = __webpack_public_path__ + "static/img/4.dff93d2.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/4.gif
// module id = Zh81
// module chunks = 1